import sortSectionFields from './sortSectionFields'

// De vragenlijst wordt opgeslagen als één platte lijst: sectiemarkeringen
// (`Type: 'section'`) en vragen door elkaar, waarbij een vraag via `SectionID`
// naar zijn sectie wijst. Elk scherm dat de lijst toont moet daar weer secties
// met vragen van maken — dit is dat recept, één keer.
//
// AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook

/**
 * @typedef {object} SectionGroup
 * @property {'section'} kind
 * @property {object} section - De sectiemarkering zelf
 * @property {Array<object>} questions - Vragen in de sectie, op SectionPosition
 */

/**
 * @typedef {object} QuestionItem
 * @property {'question'} kind
 * @property {object} question - Vraag buiten elke sectie
 */

/**
 * @param {Array<object>} fields - QuestionnaireFields van één vragenlijst, in
 *   Position-volgorde (sectiemarkeringen en vragen door elkaar).
 * @returns {Array<SectionGroup|QuestionItem>} De items op het hoogste niveau, in
 *   dezelfde volgorde; secties dragen hun eigen vragen bij zich.
 */
const groupFieldsBySection = (fields) => {
    if (!Array.isArray(fields)) return []

    return fields
        .filter((field) => (field?.SectionID || '') === '')
        .map((field) => {
            if (field?.Type !== 'section') return { kind: 'question', question: field }

            return {
                kind: 'section',
                section: field,
                questions: sortSectionFields(fields.filter((child) => child?.SectionID === field.ID)),
            }
        })
}

export default groupFieldsBySection
